import useCurrentOrganization from './useCurrentOrganization';

const useIsViewOnlyEnabled = (): boolean => {
  const currentOrganization = useCurrentOrganization();

  return !!currentOrganization?.viewOnlyMembersEnabled;
};

export default useIsViewOnlyEnabled;
